// extracted by mini-css-extract-plugin
export default {"hidden":"styles_hidden__sB9ZE","uploadContainer":"styles_uploadContainer__V7ipn","uploadText":"styles_uploadText__Aqqbn","uploadHint":"styles_uploadHint__KUHOx"};